module.exports = __webpack_public_path__ + "static/media/firework.801b2c49.gif";